import React from "react";
import { formatBbPrice } from "../../../utils/common";
import GeneralToolTip from "./general-tooltip";

const BarChartTooltip = ({ payload, showFormattedValue = true }) => {
  const hoveredItem = payload && payload[0];
  if (!hoveredItem) return null;

  const colorValue = hoveredItem.color ?? hoveredItem.fill ?? "";
  const rawValue = hoveredItem.value;
  const formattedValue = formatBbPrice(rawValue);

  const toolTipPayloadValue = showFormattedValue
    ? `${hoveredItem.name}: ${rawValue} (${formattedValue})`
    : `${hoveredItem.name}: ${rawValue}`;

  return (
    <GeneralToolTip
      color={colorValue}
      field={toolTipPayloadValue}
      bgColor={hoveredItem.fill}
    />
  );
};

export default BarChartTooltip;
